import type { NdisCataloguePackage, NdisSupportCatalogueItem } from './types';
import official from './data/ndis-support-catalogue-2026-27.json';

/** Official NDIA Support Catalogue 2026-27 (parsed from media/8038 XLSX). */
export function loadOfficialNdisSupportCatalogue(): NdisCataloguePackage {
  const pkg = official as NdisCataloguePackage;
  if (!pkg?.items?.length) {
    throw new Error('ndis_official_catalogue_missing');
  }
  return {
    meta: { ...pkg.meta },
    items: pkg.items as NdisSupportCatalogueItem[],
  };
}

/** @deprecated use loadOfficialNdisSupportCatalogue — kept as alias for call sites */
export function generateNationalNdisSupportCatalogue(
  _effectiveFrom?: string,
): NdisCataloguePackage {
  return loadOfficialNdisSupportCatalogue();
}

let cached: NdisCataloguePackage | null = null;

export function loadBundledNdisCatalogueSeed(): NdisCataloguePackage {
  if (!cached) cached = loadOfficialNdisSupportCatalogue();
  return cached;
}

export function assertNdisCatalogueNonEmpty(pkg: NdisCataloguePackage): void {
  if (!pkg.items.length) throw new Error('ndis_catalogue_empty');
  if (!pkg.meta.contentSha256 || !pkg.meta.sourceUrl || !pkg.meta.effectiveFrom) {
    throw new Error('ndis_catalogue_provenance_incomplete');
  }
  if (!pkg.meta.sourceUrl.includes('ndis.gov.au')) {
    throw new Error('ndis_catalogue_source_not_ndia');
  }
}

export function ndisItemToMdmRow(item: NdisSupportCatalogueItem) {
  return {
    service_code: item.supportItemNumber,
    program: 'NDIS' as const,
    category: item.supportCategory,
    display_name: item.supportItemName,
    description: `${item.registrationGroupName} (${item.registrationGroup})`,
    default_unit_type: item.unit,
    worker_classification_minimum: null as string | null,
    is_active: true,
    effective_from: item.effectiveFrom,
    effective_to: item.effectiveTo,
  };
}
